export const AVATAR_FALLBACK = "/avatar-placeholder.webp";
